import { useEffect, useRef } from "react";
import { X } from "lucide-react";
import { Color } from "utils/theme";
import { Button } from "components/ui/button";

interface SheetProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
}

export const Sheet = ({ open, onClose, title, children }: SheetProps) => {
  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    if (open) document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      <div
        ref={overlayRef}
        className="fixed inset-0 z-40 opacity-40"
        style={{ background: "#000" }}
        onClick={onClose}
      />
      <div
        className="fixed top-0 right-0 h-full z-50 w-full md:w-[600px] flex flex-col"
        style={{
          background: Color.Primary[900],
          borderLeft: `1px solid ${Color.Primary[700]}`,
        }}
      >
        <div
          className="flex items-center justify-between px-4 py-3 shrink-0"
          style={{ borderBottom: `1px solid ${Color.Primary[700]}` }}
        >
          {title && <span className="text-2xl font-medium">{title}</span>}
          <Button
            className="ml-auto"
            onClick={onClose}
            aria-label="Close settings"
            variant="ghost"
          >
            <X
              className="w-6 h-6 pointer-events-none"
              style={{ color: Color.Primary[400] }}
            />
          </Button>
        </div>
        <div className="flex-1 overflow-y-auto px-4 py-5 pb-10">{children}</div>
      </div>
    </>
  );
};
